import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../cn.js';
const SIZES = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-11 w-11 text-sm',
    lg: 'h-16 w-16 text-lg',
};
function initialsOf(name) {
    if (!name)
        return '?';
    const parts = name.trim().split(/\s+/).slice(0, 2);
    return parts.map((part) => part.charAt(0).toUpperCase()).join('') || '?';
}
/** Falls back to initials when there is no photo, or when the photo fails to load. */
export function Avatar({ name, src, size = 'md', className }) {
    const [failed, setFailed] = useState(false);
    const showImage = Boolean(src) && !failed;
    return (_jsx("span", { className: cn('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full', 'bg-primary-light font-semibold text-primary-dark', SIZES[size], className), children: showImage ? (_jsx("img", { src: src, alt: name ?? '', loading: "lazy", decoding: "async", className: "h-full w-full object-cover", onError: () => setFailed(true) })) : (_jsx("span", { "aria-hidden": "true", children: initialsOf(name) })) }));
}
//# sourceMappingURL=Avatar.js.map